export default __webpack_public_path__ + "static/objego-50b78265244c4cb62f9c858a8cfad917.svg";